$bog_music_tracks $mol_list
	track_keys /
	current_key \
	play_key? null
	archive_mode false
	reorder_to? null
	archive_key? null
	restore_key? null
	delete_key? null
	demote_key? null
	rows <= track_rows /
		<= Track*0 $bog_music_track
			key <= track_key* \
			current <= track_current* false
			play? <=> track_play*? null
			archive_mode <= archive_mode
			can_drag <= track_can_drag* false
			drag_start? <=> track_drag_start*? null
			drop_here? <=> track_drop_here*? null
			archive? <=> track_archive*? null
			restore? <=> track_restore*? null
			delete_forever? <=> track_delete*? null
			demote? <=> track_demote*? null
